import { DatePickerField } from "../../../blueplanitUtils/InputField";
import dayjs from "dayjs";
import AttachmentsHistory from "./clinetAttachmentHistory";
import Subscription from "./Invoice/Subscription";
import { useState } from "react";
import { AntdButton } from "../../../blueplanitUtils/InputField";
import { message } from "antd";

const DateComponent = ({ agencyData, setAgencyData }) => {
  const [openSubscription, setOpenSubscription] = useState(false);

  const getDateTimeValue = (datevalue) => {
    let finalDate = null;
    if (datevalue !== undefined || datevalue !== '') {
      if (typeof datevalue === 'string' && datevalue?.length === 13) {
        finalDate = dayjs(parseInt(datevalue))
      } else if (typeof datevalue === 'object') {
        finalDate = datevalue
      }
    }
    return finalDate;
  }
  const handleDateChange = (name, date) => {
    // Update the agencyData with the selected date in the PartnershipDetails
    setAgencyData({
      ...agencyData,
      PartnershipDetails: {
        ...agencyData.PartnershipDetails,
        [name]: date, // Ensure the date is in the correct format
      },
    });
  };
  return (
    <div className="tab-box" style={{ marginTop: "6px" }}>
      <div className="col-md-12 d-flex overflow-hidden mb-4">
        <div className="card profile-box flex-fill">
          <div className="card-body">
            <h3
              className="card-title"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: '-7px'
              }}
            >
              <b>Subscriptions</b>
              <AntdButton
                type="primary"
                variant="contained"
                size="medium"
                onClick={() => {
                  if (agencyData?.id) {
                    setOpenSubscription(true);
                  } else {
                    message.info({
                      content: "Subscription can only be created after client is added or created.",
                      duration: 3,
                    });
                  }
                }}
                label="+ Create Subscription"
              />
            </h3>
            <Subscription
              clientId={agencyData?.id}
              agencyName={agencyData?.clientName}
              agencyData={agencyData}
              openFromHeader={openSubscription}
              onCloseFromHeader={() => setOpenSubscription(false)}
            />
          </div>
        </div>
      </div>

      <div style={{ marginBottom: "-15px" }} />
      <div className="card tab-box" style={{ marginTop: "6px" }}>

        <div className="row d-flex justify-content-between p-3">
          <div className="col-md-3 mb-3 mt-2">
            <DatePickerField
              formcontrol="form-control"
              label="Trial Period Start Date"
              name="TrialPeriodStart"
              value={getDateTimeValue(agencyData?.PartnershipDetails?.TrialPeriodStart)} // Format as DD/MM/YYYY
              onChange={(date) => handleDateChange("TrialPeriodStart", date)} // Update the state on change
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              getPopupContainer={(trigger) => trigger.parentElement}
              onFocus={(e) => e.preventDefault()}
              autoFocus={false}
            />
          </div>

          {/* Trial Period End Date */}
          <div className="col-md-3 mb-2 mt-2">
            <DatePickerField
              formcontrol="form-control"
              label="Trial Period End Date"
              name="TrialPeriodEnd"
              value={getDateTimeValue(agencyData?.PartnershipDetails?.TrialPeriodEnd)}
              onChange={(date) => handleDateChange("TrialPeriodEnd", date)} // Update the state on change
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              getPopupContainer={(trigger) => trigger.parentElement}
              onFocus={(e) => e.preventDefault()}
              autoFocus={false}
            />
          </div>

          {/* Contract Start Date */}
          <div className="col-md-3 mb-2 mt-2">
            <DatePickerField
              formcontrol="form-control"
              label="Contract Start Date"
              name="ContractStart"
              value={getDateTimeValue(agencyData?.PartnershipDetails?.ContractStart)}
              onChange={(date) => handleDateChange("ContractStart", date)} // Update the state on change
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              getPopupContainer={(trigger) => trigger.parentElement}
              onFocus={(e) => e.preventDefault()}
              autoFocus={false}
            />
          </div>

          {/* Contract End Date */}
          <div className="col-md-3 mb-2 mt-2">
            <DatePickerField
              formcontrol="form-control"
              label="Contract End Date"
              name="ContractEnd"
              value={getDateTimeValue(agencyData?.PartnershipDetails?.ContractEnd)}
              onChange={(date) => handleDateChange("ContractEnd", date)} // Update the state on change
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              getPopupContainer={(trigger) => trigger.parentElement}
              onFocus={(e) => e.preventDefault()}
              autoFocus={false}
            />
          </div>
        </div>

        {/* Attachments History */}
        <AttachmentsHistory />
      </div>
    </div>
  );

};

export default DateComponent;
